import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import createDebounce from 'redux-debounced';
import paymentDisputeManagerReducer from '../reducers/paymentDisputeManagerReducer';

const configureStore = (railsProps) => (
  createStore(paymentDisputeManagerReducer, railsProps, applyMiddleware(createDebounce(), thunk))
);

export default configureStore;
